import { Link } from 'react-router-dom';
import { allComics } from '@/mocks/comics';

export default function PopularRanking() {
  const ranked = [...allComics]
    .sort((a, b) => b.views - a.views)
    .slice(0, 10);

  return (
    <section className="py-14 bg-background-50" aria-labelledby="ranking-heading">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 id="ranking-heading" className="font-heading text-2xl text-foreground-950 mb-8">
          热门排行
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {[ranked.slice(0, 5), ranked.slice(5, 10)].map((group, groupIdx) => (
            <div key={groupIdx} className="bg-white rounded-xl p-5">
              {group.map((comic, idx) => {
                const rank = groupIdx === 0 ? idx + 1 : idx + 6;
                return (
                  <Link
                    key={comic.id}
                    to={`/comic/${comic.id}`}
                    className={`flex items-center gap-4 py-3 group ${
                      idx < group.length - 1 ? 'border-b border-background-200' : ''
                    }`}
                  >
                    <span
                      className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${
                        rank <= 3
                          ? 'bg-primary-500 text-white'
                          : 'bg-foreground-100 text-foreground-500'
                      }`}
                    >
                      {rank}
                    </span>
                    <div className="w-12 h-16 flex-shrink-0 rounded-md overflow-hidden">
                      <img
                        src={comic.cover}
                        alt={comic.title}
                        title={`${comic.title} - 樱花动漫91热门漫画`}
                        className="w-full h-full object-cover object-top"
                        loading="lazy"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 truncate">
                        {comic.title}
                      </h4>
                      <p className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">{comic.author}</p>
                      <div className="flex items-center gap-2 mt-1 text-xs text-foreground-400">
                        <span className="text-accent-500 font-medium whitespace-nowrap">{comic.rating}分</span>
                        <span className="whitespace-nowrap">{comic.status}</span>
                      </div>
                    </div>
                    <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                      <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors duration-200"></i>
                    </div>
                  </Link>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}